import { Channel } from 'pusher-js';
import { Reports } from 'typings/reports';
import { IComponentController } from 'angular';
import { Id, toast } from 'react-toastify';
import template from './printing-options.html?raw';
import style from './printing-options.module.scss';
import { PrintingOptionsService } from '../../services/printing-options/printing-options.service';

class PrintingOptions implements IComponentController {
  style = style;
  channel: Channel | null = null;

  private documentSuccessPreparedToastId: Id | undefined;

  static $inject = ['PrintingOptionsService'];

  constructor(private PrintingOptionsService: PrintingOptionsService) {}

  $onInit(): void {
    this.PrintingOptionsService.getReports(0);
  }

  $onDestroy(): void {
    this.PrintingOptionsService.showDocumentQueue = false;
    toast.dismiss(this.documentSuccessPreparedToastId);
  }

  get showDocumentQueue(): boolean {
    return this.PrintingOptionsService.showDocumentQueue;
  }

  get hasPendingReports(): boolean {
    return this.hasReports(['calculating', 'initial', 'pending']);
  }

  get hasCompleteReports(): boolean {
    return this.hasReports(['complete']);
  }

  toggleDocumentQueue(): void {
    this.PrintingOptionsService.showDocumentQueue = !this.PrintingOptionsService.showDocumentQueue;
    toast.dismiss(this.documentSuccessPreparedToastId);
  }

  private hasReports(states: Reports.State[]): boolean {
    return !!this.PrintingOptionsService.reports.find((report) => {
      return states.includes(report.state) && !report.printed_at;
    });
  }
}

const PrintingOptionsComponent: ng.IComponentOptions = {
  controller: PrintingOptions,
  template,
  bindings: {},
};

export { PrintingOptionsComponent };
